<template>
  <router-view :me="me"></router-view>
</template>

<script>
export default {
  name: "Administration",
  props: ["me"]
};
</script>